/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon payment status dictionary
 */
export enum FalconPaymentStatus {
  Unsettled = 0,
  Settled
}
